import { dom, library } from "@fortawesome/fontawesome-svg-core";

import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";

import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons/faGraduationCap";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons/faBriefcase";
import { faWrench } from "@fortawesome/free-solid-svg-icons/faWrench";
import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons/faProjectDiagram";
import { faHeadset } from "@fortawesome/free-solid-svg-icons/faHeadset";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons/faMapMarker";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faFax } from "@fortawesome/free-solid-svg-icons/faFax";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons/faCalendarAlt";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons/faUserSecret";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { faChalkboardTeacher } from "@fortawesome/free-solid-svg-icons/faChalkboardTeacher";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons/faPencilAlt";
import { faPenAlt } from "@fortawesome/free-solid-svg-icons/faPenAlt";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons/faLocationArrow";

import { faNewspaper } from "@fortawesome/free-regular-svg-icons/faNewspaper";
import { faImages } from "@fortawesome/free-regular-svg-icons/faImages";

library.add(faFacebook, faLinkedin);

library.add(
  faHome,
  faUniversity,
  faGraduationCap,
  faBriefcase,
  faWrench,
  faProjectDiagram,
  faHeadset,
  faMapMarker,
  faPhone,
  faFax,
  faEnvelope,
  faCalendarAlt,
  faClock,
  faUser,
  faUserSecret,
  faGlobe,
  faChalkboardTeacher,
  faChevronLeft,
  faChevronRight,
  faPencilAlt,
  faPenAlt,
  faUsers,
  faLocationArrow
);

library.add(faNewspaper, faImages);

dom.i2svg();



// WEBPACK FOOTER //
// ./js/inc/font-awesome.js